//
//
//
//

import LoaderSpinner from '~/static/icon_spinner.svg?inline';

export default {
  components: {
    LoaderSpinner,
  },
};
